
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard } from '@/components';
import useGooglePayment from '@/modules/google/model/payment';
import { ROUTE_NAME_GOOGLE } from '@/modules/google/router';

export default defineComponent({
    name: ROUTE_NAME_GOOGLE.PAYMENT,
    components: { AppFormRow, AppInput, AppButton, AppCard },
    setup() {
        const { model, v$, fetch, actions } = useGooglePayment();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, actions };
    }
});
